import { render } from "./ShowInfoScreenDialog.vue?vue&type=template&id=38e676ac"
import script from "./ShowInfoScreenDialog.vue?vue&type=script&lang=js"
export * from "./ShowInfoScreenDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__